const WELLSKY_ACCOUNT_HOST_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*\.clearcareonline\.com$/;
const URL_SCHEME_PATTERN = /^https?:\/\//;
const EVERYTHING_AFTER_HOST_PATTERN = /[/?#][\s\S]*$/;
export const WELLSKY_ACCOUNT_DOMAIN_EXAMPLE = "youragency.clearcareonline.com";
export function normalizeWellSkyAccountName(accountName) {
    return accountName
        .trim()
        .toLowerCase()
        .replace(URL_SCHEME_PATTERN, "")
        .replace(EVERYTHING_AFTER_HOST_PATTERN, "")
        .trim();
}
export function isValidWellSkyAccountName(accountName) {
    return WELLSKY_ACCOUNT_HOST_PATTERN.test(normalizeWellSkyAccountName(accountName));
}
const WELLSKY_AGENCY_ID_PATTERN = /^\d+$/;
const AGENCY_ID_SEPARATOR_PATTERN = /[\s,]/g;
export function normalizeWellSkyAgencyId(agencyId) {
    return agencyId.replace(AGENCY_ID_SEPARATOR_PATTERN, "");
}
export function isValidWellSkyAgencyId(agencyId) {
    return WELLSKY_AGENCY_ID_PATTERN.test(normalizeWellSkyAgencyId(agencyId));
}
//# sourceMappingURL=wellsky-account.js.map